import { render, staticRenderFns } from "./personSelect.vue?vue&type=template&id=0d7ad690&"
import script from "./personSelect.vue?vue&type=script&lang=js&"
export * from "./personSelect.vue?vue&type=script&lang=js&"
import style0 from "./personSelect.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports